import React from 'react'
import {Icon} from '@chakra-ui/react'

const UpIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                d="M20.6527 39C20.1412 39 19.7227 38.5815 19.7227 38.07V1.93C19.7227 1.4185 20.1412 1 20.6527 1C21.1642 1 21.5827 1.4185 21.5827 1.93V38.07C21.5827 38.5815 21.1642 39 20.6527 39Z"
                fill="currentColor"
            />
            <path
                d="M7.93043 15.7499C7.69793 15.7499 7.45613 15.6569 7.27943 15.4802C6.91673 15.1175 6.90743 14.5316 7.27943 14.1689L19.9926 1.279C20.3553 0.916302 20.9412 0.907002 21.3039 1.279C21.6666 1.64171 21.6759 2.22761 21.3039 2.59031L8.59074 15.4709C8.40474 15.6569 8.17224 15.7499 7.93043 15.7499Z"
                fill="currentColor"
            />
            <path
                d="M33.3564 15.7499C33.1146 15.7499 32.8728 15.6569 32.6961 15.4709L19.9736 2.58102C19.6109 2.21831 19.6202 1.62311 19.9736 1.26971C20.3363 0.907008 20.9222 0.916308 21.2849 1.26971L34.0074 14.1596C34.3701 14.5223 34.3608 15.1175 34.0074 15.4709C33.8307 15.6476 33.5889 15.7406 33.3564 15.7406V15.7499Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default UpIcon
